import { render, staticRenderFns } from "./create_service.vue?vue&type=template&id=1abb6084&scoped=true"
import script from "./create_service.vue?vue&type=script&lang=js"
export * from "./create_service.vue?vue&type=script&lang=js"
import style0 from "./create_service.vue?vue&type=style&index=0&id=1abb6084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb6084",
  null
  
)

export default component.exports